import { render, staticRenderFns } from "./BindWallet.vue?vue&type=template&id=7e2e02b2&scoped=true"
import script from "./BindWallet.vue?vue&type=script&lang=js"
export * from "./BindWallet.vue?vue&type=script&lang=js"
import style0 from "./BindWallet.vue?vue&type=style&index=0&id=7e2e02b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2e02b2",
  null
  
)

export default component.exports